module.exports = __webpack_public_path__ + "static/assets/00505ca954aec95aac898ee7d5a7ee6c.svg";